import { DE } from './privacy-policy/DE';
import { EN } from './privacy-policy/EN';
import { UK } from './privacy-policy/UK';
export const privacyPolicy = {
  en: EN,
  uk: UK,
  de: DE,
};
